import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/progress/index.js
// module id = 320
// module chunks = 0